class Accordion99 extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.accordion-99__item'));

    this.items.forEach((item) => {
      const trigger = item.querySelector('.accordion-99__trigger');
      trigger.addEventListener('click', () => this.toggleItem(item));
    });
  }

  toggleItem(item) {
    const isOpen = item.classList.contains('is-open');

    this.items.forEach((otherItem) => {
      if (otherItem === item) return;
      otherItem.classList.remove('is-open');
      otherItem.querySelector('.accordion-99__trigger').setAttribute('aria-expanded', 'false');
    });

    item.classList.toggle('is-open', !isOpen);
    item.querySelector('.accordion-99__trigger').setAttribute('aria-expanded', String(!isOpen));
  }
}

customElements.define('accordion-99', Accordion99);